module.exports = __webpack_public_path__ + "static/media/inf_29og30.5761795a.mp3";